import { listEmailDomainBlocked } from '@/constants'

export const checkIsFromEmailDomainBlocked = (email: string): boolean => {
  return listEmailDomainBlocked.includes(email.split('@')[1])
}
